import { useEffect, useRef, useState } from 'react';

/**
 * Custom hook to determine the direction of the price change animation
 */
export const usePriceDirection = (currentPrice: number) => {
  const [direction, setDirection] = useState<'up' | 'down'>('down'); // Initial direction
  const previousPrice = useRef<number | null>(null); // To track the previous price

  useEffect(() => {
    if (previousPrice.current !== null) {
      // If the previous price exists, compare with the current price
      if (currentPrice > previousPrice.current) {
        setDirection('down'); // Price increased, animate downwards
      } else if (currentPrice < previousPrice.current) {
        setDirection('up'); // Price decreased, animate upwards
      }
    }
    // Update the previous price with the current price
    previousPrice.current = currentPrice;
  }, [currentPrice]);

  return direction;
};
